import { useEffect, useRef, useState } from 'react';

const useGlobals = (variables: string[], interval: number = 100) => {
  const [globals, setGlobals] = useState<any>({});
  const mounted = useRef<boolean>(true);
  useEffect(() => {
    variables.forEach(v => {
      if (Object.keys(globals).includes(v)) return;

      const i = setInterval(() => {
        // console.log('running');
        if (window[v]) {
          mounted && setGlobals(prev => ({ ...prev, [v]: window[v] }));
          clearInterval(i);
        }
      }, interval);

      setTimeout(() => clearInterval(i), 1000);

      return () => {
        mounted.current = false;
      };
    });
  }, [interval, globals, variables, setGlobals]);

  return globals;
};

export default useGlobals;
